// Shared React Query cache keys for the college document library, so every hook that reads or
// invalidates folder/file/search data agrees on the same key shape.
export const FOLDERS_QUERY_KEY = "college-folders";
export const FILES_QUERY_KEY = "college-files";
export const SEARCH_QUERY_KEY = "college-search";
export const MAPPING_QUERY_KEY = "college-mapping";
export const PREFILL_KEYS_QUERY_KEY = "college-prefill-keys";
export const COPY_SOURCES_QUERY_KEY = "college-copy-sources";
export const SEND_CLIENTS_QUERY_KEY = "college-send-clients";
export const SEND_ADMISSIONS_QUERY_KEY = "college-send-admissions";
export const SENDS_QUERY_KEY = "college-sends";
